export function canQueueShipping(item) {
  return item && item.STATUS === 'wait_shipping' && String(item.SHIPPING_NOTIFICATION) === '0';
}

export function shippingStatusText(item) {
  const labels = {
    '1': '過去の発送予約：自動送信を保留しています。',
    '2': '発送通知済み',
    '3': '発送通知を予約済みです。送信処理を待っています。',
    '4': '送信中、または結果の確認が必要です。自動再送は行いません。',
    '5': '状態を確認できないか発送対象外のため、送信していません。管理者へ確認してください。',
    '6': 'メルカリで発送済み・取引完了を確認しました。SELLERSからは送信していません。'
  };
  return labels[String(item && item.SHIPPING_NOTIFICATION)] || '';
}

export function isShippingReservationAccepted(response) {
  return !!(response && response.data && response.data.ok === true && response.data.shippingState === '3');
}
